export default __webpack_public_path__ + "static/media/gallery34.7bc04f25.jpg";